import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-10" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import MultiSelect from "primevue/multiselect";
import Skeleton from "primevue/skeleton";

import { ref, watch, onMounted, computed } from "vue";
import { useCatalogData } from "./useCatalogData";


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogDataBaseInput',
  props: [
  "modelValue",
  "isSegmentSetted",
  "selectType",
  "useIdOnly",
  "notSearch",
],
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const catalogDataSettings = ref({
  isLoading: false,
  filterStr: "",
  debounceTimeout: null as number | null,
  isLoadingFirst: true,
  optionName: "",
  optionValue: "",
  isLoadedAll: false,
});

const {
  store,
  items,
  optionName,
  addScrollHundler,
  updateSettings,
  onFilterItems,
  getSortingArray,
  sendItemRequest,
  replaceItems,
} = useCatalogData(
  props.selectType,
  catalogDataSettings.value,
  props.useIdOnly
);

const emit = __emit;

let element: Element | null = null;

const isLoading = computed(() => {
  return (
    catalogDataSettings.value.isLoading ||
    catalogDataSettings.value.isLoadingFirst
  );
});

const isEmpty = computed(() => {
  return items.value.length === 0;
});

const emptyMessageComputed = computed(() => {
  return isLoading.value ? "Поиск вариантов..." : "Нет доступных вариантов";
});

const emptyFilterMessageComputed = computed(() => {
  return isLoading.value ? "Поиск вариантов..." : "Результатов не найдено";
});

watch(
  () => catalogDataSettings.value.filterStr,
  () => {
    store.sortItems(getSortingArray(props.modelValue));
    if (catalogDataSettings.value.debounceTimeout)
      clearTimeout(catalogDataSettings.value.debounceTimeout);
    catalogDataSettings.value.debounceTimeout = setTimeout(
      sendItemRequest,
      1000,
      props.modelValue
    );
  },
  { immediate: true }
);

watch(
  () => catalogDataSettings.value,
  (newValue) => {
    updateSettings(newValue);
  }
);

watch(
  () => props.modelValue,
  (newValue) => {
    if (
      catalogDataSettings.value.isLoadingFirst &&
      newValue != null &&
      newValue.length > 0
    ) {
      catalogDataSettings.value.isLoading = true;
      store.getItems("", getSortingArray(newValue), true, true).then(() => {
        catalogDataSettings.value.isLoadingFirst = false;
        const items = replaceItems(newValue);
        if (items.length) emit("update:modelValue", items);
        setTimeout(() => {
          catalogDataSettings.value.isLoading = false;
        }, 200);
      });
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (!store.itemList.length) {
    catalogDataSettings.value.isLoading = true;
    store
      .getItems("", getSortingArray(props.modelValue), true, true, 0, 50, true)
      .then(() => {
        catalogDataSettings.value.isLoadingFirst = false;
        catalogDataSettings.value.isLoading = false;
      })
      .catch(() => {
        catalogDataSettings.value.isLoadingFirst = false;
        catalogDataSettings.value.isLoading = false;
      });
  } else if (store.isLoadingInitial && store.initialLoadPromise) {
    catalogDataSettings.value.isLoading = true;
    store.initialLoadPromise
      .then(() => {
        catalogDataSettings.value.isLoadingFirst = false;
        catalogDataSettings.value.isLoading = false;
      })
      .catch(() => {
        catalogDataSettings.value.isLoadingFirst = false;
        catalogDataSettings.value.isLoading = false;
      });
  } else {
    catalogDataSettings.value.isLoadingFirst = false;
  }
});

const beforeShowItems = () => {
  store.sortItems(getSortingArray(props.modelValue));
};

const showItems = () => {
  element = document.querySelectorAll(
    ".p-multiselect-panel .p-multiselect-items-wrapper"
  )[0];
  if (element) addScrollHundler(element);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MultiSelect), {
    modelValue: props.modelValue,
    options: _unref(items),
    display: "chip",
    optionLabel: _unref(optionName).label,
    placeholder: 
      isLoading.value && isEmpty.value
        ? 'Поиск вариантов...'
        : __props.isSegmentSetted
        ? 'Не выбрано'
        : 'Выберите значение'
    ,
    class: _normalizeClass(__props.isSegmentSetted ? 'hidden' : ''),
    filter: !__props.isSegmentSetted && !__props.notSearch,
    onFilter: _unref(onFilterItems),
    "option-value": __props.useIdOnly ? _unref(optionName).pk : undefined,
    appendTo: "self",
    onBeforeShow: beforeShowItems,
    showToggleAll: !__props.isSegmentSetted,
    onShow: showItems,
    disabled: __props.isSegmentSetted,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = 
      ($event) => {
        emit('update:modelValue', $event);
        catalogDataSettings.value.isLoadingFirst = false;
      }
    ),
    loading: isLoading.value,
    emptyMessage: emptyMessageComputed.value,
    emptyFilterMessage: emptyFilterMessageComputed.value
  }, _createSlots({
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(props.modelValue.length) + " выбрано", 1)
    ]),
    option: _withCtx((slotProps) => [
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(slotProps.option[_unref(optionName).label]), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_unref(Skeleton), {
                width: "10rem",
                class: "mb-2"
              })
            ])
          ]))
    ]),
    _: 2
  }, [
    (isLoading.value)
      ? {
          name: "value",
          fn: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(props.modelValue.length != 0 ? 'any-catalog' : '')
            }, "   ", 2)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "options", "optionLabel", "placeholder", "class", "filter", "onFilter", "option-value", "showToggleAll", "disabled", "loading", "emptyMessage", "emptyFilterMessage"]))
}
}

})